module.exports = __webpack_public_path__ + "31db1602c945ce0b418c3b641f2bec88.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/beaker.png
// module id = 2487
// module chunks = 0